export default {"src":"/_next/static/media/plus-symbol-white.38975628.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};